let closeMenuOut = document.getElementById('closeMenuOut');
closeMenuOut.remove();
document.body.appendChild(closeMenuOut);

let showHideMenuinProgress = false;

function showHideMenu () {

  if (showHideMenuinProgress) return;

  showHideMenuinProgress = true;

  let header = document.getElementById('header');

  let storeMenuTransitionDuration = getComputedStyle(header).getPropertyValue('--storeMenuDuration').includes('ms') ? parseInt( getComputedStyle(header).getPropertyValue('--storeMenuDuration') ) : parseInt( getComputedStyle(header).getPropertyValue('--storeMenuDuration') ) * 1000;

  let storeLogo = document.getElementsByClassName('store-logo')[0];
  let storeMenu = document.getElementsByClassName('store-menu')[0];
  let storeMenuList = document.getElementsByClassName('store-menu-list')[0];
  let menuItem = document.getElementsByClassName('store-menuitem');
  let storeNavGeneral = document.getElementById('store-nav-general');
  let closeMenuOut = document.getElementById('closeMenuOut');
  let searchBox = document.getElementById('store-nav-search');

  let secondCategory = document.getElementsByClassName('store-categories')[1];

  if (storeMenuList.style.visibility != 'visible') {
    storeMenuList.style.visibility = 'visible';
  } else {
    storeMenuList.style.visibility = 'hidden';
  }
  

  

  if ( getComputedStyle(storeNavGeneral).display === 'none' ) {

    storeNavGeneral.style.display = 'block';
    closeMenuOut.style.display = 'block';
    searchBox.style.display = 'block';

    header.style.backdropFilter = 'blur(1.5rem)';
    header.style.webkitBackdropFilter = 'blur(1.5rem)';
    header.style.backgroundColor = 'rgba(210,210,210,0.2)';
    header.style.bottom = '0';
    header.style.borderRight = '1px solid rgba(255,255,255,0.2)';

    storeLogo.style.opacity = '1';
    storeMenu.style.opacity = '1';

    for ( let i = 0; i < menuItem.length; i++ ) {
      menuItem[i].style.transition = 'opacity ' + storeMenuTransitionDuration / menuItem.length + 'ms linear';
      setTimeout ( function () { menuItem[i].style.opacity = '1' } ,  storeMenuTransitionDuration / menuItem.length  * i );
    }

    setTimeout( () => { showHideMenuinProgress = false }, storeMenuTransitionDuration * 2);

  } else {

    storeNavGeneral.style.display = 'none';
    closeMenuOut.style.display = 'none';
    searchBox.style.display = 'none';

    header.style.backdropFilter = 'blur(0rem)';
    header.style.webkitBackdropFilter = 'blur(0rem)';
    header.style.backgroundColor = 'rgba(0,0,0,0)';
    header.style.borderRight = 'unset';

    setTimeout( function () { storeMenu.style.height = '0'; header.style.bottom = 'unset'; }, storeMenuTransitionDuration * 2);

    for ( let i = 0; i < menuItem.length; i++ ) {
      setTimeout ( function () { menuItem[i].style.opacity = '0' } , storeMenuTransitionDuration / menuItem.length * ( menuItem.length - 1 - i ) ) ;
    }

    setTimeout( () => { showHideMenuinProgress = false }, storeMenuTransitionDuration * 2);

  }

}

document.getElementById('store-menu-collection').addEventListener( 'click', showHideMenu );
document.getElementById('closeMenu').addEventListener( 'click', showHideMenu );
document.getElementById('closeMenuOut').addEventListener( 'click', showHideMenu );
document.getElementsByClassName('store-subcategories')[0].addEventListener( 'click', showHideMenu );